import React, { useState } from 'react';
import { Alert, Button, Card, Input, Space, Typography } from 'antd';
import PageTitle from '../../components/PageTitle';
import { huifuToolsQueryUser, huifuToolsSetManualWithdraw } from '../../api';

const { Text } = Typography;
const { TextArea } = Input;

const formatJson = (value) => {
  if (value == null) return '';
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

const HuifuApiTools = () => {
  const [huifuId, setHuifuId] = useState('');
  const [loading, setLoading] = useState(false);
  const [output, setOutput] = useState('');

  const run = async (action) => {
    const id = String(huifuId || '').trim();
    if (!id) {
      setOutput('请先输入 huifu_id');
      return;
    }
    setLoading(true);
    setOutput('请求中...');
    try {
      const res = action === 'query'
        ? await huifuToolsQueryUser(id)
        : await huifuToolsSetManualWithdraw(id);
      setOutput(formatJson(res));
    } catch (err) {
      const body = err.response?.data;
      setOutput(formatJson(body || { error: err.message || '请求失败' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px 0' }}>
      <PageTitle title="汇付接口工具" />

      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="调试说明"
        description={
          <div>
            <div>输入汇付 huifu_id 后调用接口，下方大框展示完整请求/响应 JSON，成功失败请自行看 resp_code 等字段。</div>
            <div style={{ marginTop: 8 }}>
              <Text type="secondary">
                「查询」= 汇付 user/basicdata/query + 本地 fangdong_ext / withdraw_mode / 银行卡；
                「改为仅手动提现」= 汇付 user/busi/modify（settle_status=0）+ 本地 withdraw_mode 写 2。
              </Text>
            </div>
          </div>
        }
      />

      <Card title="参数" style={{ marginBottom: 16 }}>
        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <div>
            <div style={{ marginBottom: 8 }}>
              <Text strong>huifu_id</Text>
            </div>
            <Input
              placeholder="请输入 18 位汇付用户编号"
              value={huifuId}
              onChange={(e) => setHuifuId(e.target.value)}
              maxLength={32}
              allowClear
            />
          </div>
          <Space wrap>
            <Button type="primary" loading={loading} onClick={() => run('query')}>
              查询当前汇付配置
            </Button>
            <Button loading={loading} danger onClick={() => run('manual')}>
              改为仅手动提现
            </Button>
            <Button disabled={loading} onClick={() => setOutput('')}>
              清空输出
            </Button>
          </Space>
        </Space>
      </Card>

      <Card title="接口返回（原始 JSON）">
        <TextArea
          value={output}
          readOnly
          placeholder="点击上方按钮后，完整返回会显示在这里"
          autoSize={{ minRows: 24, maxRows: 40 }}
          style={{
            fontFamily: 'Consolas, Monaco, "Courier New", monospace',
            fontSize: 12,
            background: '#fafafa',
          }}
        />
      </Card>
    </div>
  );
};

export default HuifuApiTools;
